import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { useAiSettings } from "@/hooks/useAiSettings";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function AiSettingsCard() {
  const { user } = useAuth();
  const { settings: s, refetch } = useAiSettings();
  const admin = user.role === "super_admin";
  const set = async (k, v) => {
    try { await api.put("/ai/settings", { [k]: v }); toast.success(v ? "Fitur AI diaktifkan" : "Fitur AI dinonaktifkan"); refetch(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  const Row = ({ k, label, hint, disabled }) => (
    <div className={cn("flex items-center justify-between gap-3 rounded-md border p-3", disabled && "opacity-50")} data-testid={`ai-setting-${k}`}>
      <div><Label className="text-sm font-medium">{label}</Label>{hint && <p className="text-xs text-muted-foreground">{hint}</p>}</div>
      <Switch checked={!!s[k]} disabled={!admin || disabled} onCheckedChange={(v) => set(k, v)} data-testid={`ai-toggle-${k}`} />
    </div>
  );
  return (
    <section className="op-card p-4" data-testid="ai-settings-card">
      <div className="mb-3 flex items-center justify-between"><h2 className="flex items-center gap-2 text-base font-semibold md:text-lg"><Sparkles className="h-5 w-5 text-pink-500" />Fitur AI (Asisten Cerdas)</h2>
        <span className={cn("rounded px-2 py-0.5 font-mono text-xs", s.enabled ? "bg-emerald-500/15 text-emerald-600" : "bg-red-500/15 text-red-600")} data-testid="ai-status">{s.enabled ? "AI ON" : "AI OFF"}</span></div>
      <p className="mb-3 text-xs text-muted-foreground">Model {s.model}. Setiap pemakaian memotong kredit Universal Key. {admin ? "Hanya Super Admin yang dapat mengubah." : "Hanya Super Admin yang dapat mengubah pengaturan ini."}{s.updated_at && <> Terakhir diubah {fmtDateTime(s.updated_at)} oleh {s.updated_by}.</>}</p>
      <div className="space-y-2">
        <Row k="enabled" label="Saklar utama AI" hint="OFF = semua fitur AI disembunyikan dan ditolak di server" />
        <Row k="intake" label="Smart Intake" hint="Kotak 'tulis permintaan' pada dialog Service Request" disabled={!s.enabled} />
        <Row k="approval_summary" label="Ringkasan & Rekomendasi Approval" hint="Tombol 'Analisis AI' di Approval Inbox" disabled={!s.enabled} />
        <Row k="assistant" label="Tanya AI (tombol mengambang)" hint="Asisten chat di pojok kanan bawah semua halaman" disabled={!s.enabled} />
      </div>
    </section>
  );
}
